<template>
	<div class="c-dashboard__wrap"
        :data-component-name="$options.name"
	>
		<TimeSheetForemanComponent />
	</div>
</template>

<script>
	import TimeSheetForemanComponent from "@/components/nav/TimeSheetForeman.vue"

	export default {
		name: "TimeSheetForeman",
		components: {
			TimeSheetForemanComponent
		},
		// props: {
		// },
		// data(){
		// },
		// methods: {
		// },
		// mounted(){
		// },
	}
</script>
